import React, { Component } from "react";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
import { connect } from "react-redux";
import styles from "./VisualitzacioSelectorPeriode.module.css";
import {
  MASCARA_DDMMYYYY,
  esDataValidaSelectorObservacions,
  convertirTextAMomentLocal
} from "../../utils/dates";
import {
  omplirDataIniciVisualitzacio,
  omplirDataFiVisualitzacio
} from "../../actions";
import {
  getDataIniciAsMoment,
  getDataFiAsMoment,
  getUsuari
} from "../../reducers";
import { isObservadorAdmin } from "../../utils/usuariRols";

class VisualitzacioSelectorPeriode extends Component {
  handleOnChangeDataInici = dataSeleccionada => {
    if (dataSeleccionada) {
      const { omplirDataIniciVisualitzacio } = this.props;
      omplirDataIniciVisualitzacio(dataSeleccionada);
    }
  };
  handleOnChangeDataFi = dataSeleccionada => {
    if (dataSeleccionada) {
      const { omplirDataFiVisualitzacio } = this.props;
      omplirDataFiVisualitzacio(dataSeleccionada);
    }
  };

  esDiaDeshabilitat = dataCalendari => {
    const { usuari } = this.props;
    const isAdmin = isObservadorAdmin(usuari);
    const dataActual = convertirTextAMomentLocal(this.props.dataActual);

    return esDataValidaSelectorObservacions(
      dataCalendari,
      dataActual,
      "days",
      isAdmin
    );
  };

  render() {
    const { dataInici, dataFi } = this.props;
    return (
      <div className={styles.visualitzacioSelectorPeriode}>
        <div>
          <div />
        </div>
        <div>
          <div className={styles.selector}>
            <label>Data inicial:</label>
            <DatePicker
              defaultValue={dataInici}
              format={MASCARA_DDMMYYYY}
              onChange={this.handleOnChangeDataInici}
              disabledDate={this.esDiaDeshabilitat}
              allowClear={false}
            />
          </div>
          <div>
            <label>Data final:</label>
            <DatePicker
              value={dataFi}
              format={MASCARA_DDMMYYYY}
              onChange={this.handleOnChangeDataFi}
              disabledDate={this.esDiaDeshabilitat}
              allowClear={false}
            />
          </div>
        </div>
      </div>
    );
  }
}

VisualitzacioSelectorPeriode.propTypes = {
  dataActual: PropTypes.object,
  omplirDataIniciVisualitzacio: PropTypes.func.isRequired,
  omplirDataFiVisualitzacio: PropTypes.func.isRequired,
  dataInici: PropTypes.object,
  dataFi: PropTypes.object,
  usuari: PropTypes.object
};

const mapStateToProps = state => {
  return {
    dataInici: getDataIniciAsMoment(state),
    dataFi: getDataFiAsMoment(state),
    usuari: getUsuari(state)
  };
};

export default connect(mapStateToProps, {
  omplirDataIniciVisualitzacio,
  omplirDataFiVisualitzacio
})(VisualitzacioSelectorPeriode);
